import { JsonSerializable } from '../shared/jsonSerializable';
import { ThirdParty } from '../entity/third-party';
import { ResultDu } from '../entity/result-du';
import { Product } from '../entity/product';
import { Package } from '../entity/package';
import * as moment from 'moment/moment';

export class Sample extends JsonSerializable {

  identifier: string;
  clientIdentifier: string;
  controlNumber: number;
  rank: number;
  type: string;
  kind: string;
  turn: string;
  takingDate: string;
  owner: ThirdParty;
  collect: ThirdParty;
  resultsDu: ResultDu[];
  product: Product;

  constructor() {
    super();
    this.identifier = null;
    this.clientIdentifier = null;
    this.controlNumber = null;
    this.rank = null;
    this.type = null;
    this.kind = null;
    this.turn = null;
    this.takingDate = null;
    this.owner = null;
    this.collect = null;
    this.resultsDu = new Array<ResultDu>();
  }

  fromJSON(jsonObj: Object) {
    for (var propName in jsonObj) {
      if (propName == "product") {
        this[propName] = new Product();
        this[propName].fromJSON(jsonObj[propName]);
      }
      if (this.hasOwnProperty(propName)) {
        if(Array.isArray(jsonObj[propName])){
          if (propName == "resultsDu") {
            for (let i in jsonObj[propName]) {
              this[propName][i] = new ResultDu();
              let item_data = jsonObj[propName][i]['resultDu'];
              if(item_data==null){
                item_data = jsonObj[propName][i];
              }
              this[propName][i].fromJSON(item_data);
            }
          }
        } else {
          if( jsonObj[propName] instanceof Object) {
            if (propName == "collect") {
              this[propName] = new ThirdParty();
              this[propName].fromJSON(jsonObj[propName]);
            }
            // if (propName == "job") {
            //   this[propName] = new Job();
            // } else if (propName == "clientRequestStatus" || propName == "limsRequestStatus") {
            //   this[propName] = new RequestStatus();
            // }
            // this[propName].fromJSON(jsonObj[propName]);
          } else {
            this[propName] = jsonObj[propName];
          }
        }
      } else {
        if (propName == "thirdParties") {
          for (let i in jsonObj[propName]) {
            let sampleThirdParty = jsonObj[propName][i]
            if( sampleThirdParty.type == "PROPRIETAIRE"){
              this.owner = new ThirdParty();
              this.owner.fromJSON(sampleThirdParty['thirdParty']);
            } else if (sampleThirdParty.type == "COLLECTEUR") {
              this.collect = new ThirdParty();
              this.collect.fromJSON(sampleThirdParty['thirdParty']);
            }
          }
        }
      }
    }
  }

  public getPackages(): Package[] {
    let packages = new Array();

    for (let i=0; i<this.resultsDu.length; i++) {
      if (!this.resultsDu[i].package.inArray(packages)) {
        packages[packages.length] = this.resultsDu[i].package;
      }
    }

    return packages;
  }

}


// WEBPACK FOOTER //
// ./src/app/entity/sample.ts